const DIGPU_LOGO = "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/v7azwox2_Digpu%20Original%20Logo%20.png";
const EICBI_LOGO = "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/2tnpeg8f_eicbi.png";
const WS_LOGO    = "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/ffrrf170_water.png";

// Safely render text with optional <em> tags — no arbitrary HTML
function renderText(str) {
  const parts = str.split(/(<em>.*?<\/em>)/g);
  return parts.map((part, i) =>
    part.startsWith("<em>") ? <em key={i}>{part.slice(4, -5)}</em> : part
  );
}

const organisers = [
  {
    id: "water-shark",
    overline: "Co-Organiser",
    name: "Water & Shark",
    logo: WS_LOGO,
    logoBg: "#1a1aff",
    founder: "CA Adv Harsh Patel",
    founderTitle: "Founder & Managing Partner",
    summary: "A global advisory firm headquartered in Singapore, operating since 2012. Specialises in cross-border tax, legal, regulatory and policy advisory, asset protection, and international wealth structuring.",
    highlights: [
      "Advises businesses, investors & family offices across 15+ jurisdictions",
      "Chief Legal Advisor to the Private Office of HH Sheikh Tahnoon Bin Saeed Bin Tahnoon Al Nahyan",
      "Dual qualifications: Chartered Accountant & Lawyer in multiple jurisdictions",
      "Entrepreneurship commenced at age 19",
    ],
  },
  {
    id: "eicbi",
    overline: "Co-Organiser",
    name: "Europe India Centre for Business and Industry",
    shortName: "EICBI",
    logo: EICBI_LOGO,
    logoBg: "#FFFFFF",
    founder: "Mr. Sujit S Nair",
    founderTitle: "Founder & Director",
    summary: "A European Parliament-accredited and European Commission-registered organisation focused on strengthening strategic engagement between India and Europe since 2011.",
    highlights: [
      "European Parliament-accredited body",
      "European Commission-registered organisation",
      "Organised policy dialogues at UK Parliament & European Parliament",
      "Publisher of <em>The Europe India Journal</em> Magazine",
      "Invited to the Global Entrepreneurship Summit 2015",
    ],
  },
];

export default function OrganizersSection() {
  return (
    <section id="organisers" data-testid="organisers-section" className="section-charcoal py-24 lg:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header — Presented by Digpu with logo */}
        <div className="text-center mb-16">
          <p className="overline-gold mb-4">Presented By</p>
          <div className="flex items-center justify-center mb-5">
            <img
              src={DIGPU_LOGO}
              alt="Digpu News & Media"
              className="h-14 w-auto object-contain"
              data-testid="digpu-logo"
            />
          </div>
          <p className="text-[#94A3B8] text-sm font-['Outfit'] mb-6">
            An internationally recognised media and PR agency bridging global diplomacy and Indian industry
          </p>
          <div className="gold-divider w-48 mx-auto" />
          <p className="overline-gold text-[0.65rem] mt-8 mb-2">Co-Organised By</p>
        </div>

        {/* Organiser cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {organisers.map(({ id, overline, name, shortName, logo, logoBg, founder, founderTitle, summary, highlights }) => (
            <div key={id} data-testid={`organiser-${id}`} className="glass-card p-8 flex flex-col gap-6">
              {/* Header */}
              <div className="flex items-start gap-4">
                {/* Actual company logo */}
                <div
                  className="w-16 h-16 flex items-center justify-center overflow-hidden flex-shrink-0"
                  style={{ background: logoBg, borderRadius: "4px" }}
                >
                  <img
                    src={logo}
                    alt={shortName || name}
                    className="w-full h-full object-contain p-1"
                  />
                </div>
                <div>
                  <p className="overline-gold text-[0.6rem] mb-1">{overline}</p>
                  <h3 className="font-['Cormorant_Garamond'] text-xl text-white font-medium leading-tight">
                    {shortName || name}
                  </h3>
                  {shortName && (
                    <p className="text-[#94A3B8] text-[0.7rem] font-['Outfit'] mt-0.5">{name}</p>
                  )}
                </div>
              </div>

              <div className="gold-divider" />

              {/* Summary */}
              <p className="text-[#CBD5E1] text-sm font-['Outfit'] leading-relaxed">{summary}</p>

              {/* Highlights — safe renderText, no dangerouslySetInnerHTML */}
              <ul className="flex flex-col gap-2">
                {highlights.map((h) => (
                  <li key={h.slice(0, 40)} className="flex items-start gap-2 text-[#94A3B8] text-xs font-['Outfit']">
                    <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-1.5 flex-shrink-0" />
                    <span>{renderText(h)}</span>
                  </li>
                ))}
              </ul>

              <div className="gold-divider" />

              {/* Founder */}
              <div>
                <p className="overline-gold text-[0.6rem] mb-1">Leadership</p>
                <p className="font-['Cormorant_Garamond'] text-lg text-white font-medium">{founder}</p>
                <p className="text-[#94A3B8] text-xs font-['Outfit'] mt-0.5">{founderTitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
